import { render, staticRenderFns } from "./ContentRenderer.vue?vue&type=template&id=18bfcca9&scoped=true"
import script from "./ContentRenderer.vue?vue&type=script&lang=js"
export * from "./ContentRenderer.vue?vue&type=script&lang=js"
import style0 from "./ContentRenderer.vue?vue&type=style&index=0&id=18bfcca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfcca9",
  null
  
)

export default component.exports